import {AfterViewInit, Component, ViewChild} from '@angular/core';
import {ModalDirective} from 'ngx-bootstrap/modal';
import {ModalBaseComponent} from 'web-common/src/app/modals/modal-factory/modal-base/modal-base.component';
import {AdminAvailableModals} from '../admin-available-modals';
import {User} from 'web-common/src/app/user/user';


@Component({
    selector: 'app-confirm-make-user-admin',
    templateUrl: './confirm-make-user-admin.component.html',
    standalone: false
})
export class ConfirmMakeUserAdminComponent extends ModalBaseComponent<any> implements AfterViewInit {

  @ViewChild('confirmMakeUserAdmin', { static: true }) public modalView: ModalDirective;

  ngAfterViewInit() {
    this.modalId = AdminAvailableModals.CONFIRM_MAKE_USER_ADMIN;
    this.modalView.show();
  }

  public returnType(obj) {
    return typeof obj;
  }
}
